import React, { useLayoutEffect, useRef, useState } from "react"
import { Box, Typography } from "@mui/material"
import RecipeDayColumn from "./RecipeDayColumn"
import { COLORS } from "../../../../utils"

const RecipeCalendar = ({
  days, recipesBySlot, onRemoveRecipe, onChooseProdDay,
  draggedRecipeId, dropTarget, onCardDragStart, onCardDragEnd, onZoneDragOver, onZoneDragLeave, onZoneDrop,
  catRank, onSortSlot,
}) => {
  const groupRefs = useRef({})
  const [groupHeight, setGroupHeight] = useState(null)

  useLayoutEffect(() => {
    setGroupHeight(null)
  }, [days, recipesBySlot])

  useLayoutEffect(() => {
    if (groupHeight !== null) return
    const heights = Object.values(groupRefs.current)
      .filter(Boolean)
      .map((el) => el.scrollHeight)
    if (heights.length === 0) return
    setGroupHeight(Math.max(...heights))
  }, [groupHeight, days, recipesBySlot])

  return (
    <Box className="stretch overflowAuto flex1" sx={sx.area}>
      {days.map((day) => {
        const colCount = day.slots.length || 1
        return (
          <Box
            key={day.date}
            ref={(el) => { groupRefs.current[day.date] = el }}
            className="flexColumn stretch"
            sx={{
              ...sx.group, flex: colCount, minWidth: `${180 * colCount}px`,
              height: groupHeight ? `${groupHeight}px` : "auto",
            }}
          >
            <Typography sx={sx.banner}>{day.label}</Typography>
            <Box className="stretch" sx={sx.slots}>
              {day.slots.map((slot) => (
                <RecipeDayColumn
                  key={slot.id}
                  slot={slot}
                  placements={recipesBySlot[slot.id] || []}
                  onRemoveRecipe={onRemoveRecipe}
                  onChooseProdDay={onChooseProdDay}
                  draggedRecipeId={draggedRecipeId}
                  dropTarget={dropTarget}
                  onCardDragStart={onCardDragStart}
                  onCardDragEnd={onCardDragEnd}
                  onZoneDragOver={onZoneDragOver}
                  onZoneDragLeave={onZoneDragLeave}
                  onZoneDrop={onZoneDrop}
                  catRank={catRank}
                  onSortSlot={onSortSlot}
                />
              ))}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default RecipeCalendar

const sx = {
  area: { display: "flex", flexDirection: "row", gap: "20px", p: "0 20px 20px", minHeight: 0 },
  group: { minWidth: "180px" },
  banner: {
    fontSize: 16, fontWeight: 500, color: COLORS.GREY_900, textAlign: "center",
    p: "12px", textTransform: "capitalize", bgcolor: COLORS.PRIMARY_BLUE_50, borderRadius: "8px 8px 0 0",
  },
  slots: { display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: "auto" },
}
